import React from 'react'
import Title from './text/Title';

export const FourOhFour = ({children, text}) => (
	<Title>{text ? text : children}</Title>
)